import {
  Directive,
  forwardRef,
  HostBinding,
  Renderer2,
  ElementRef,
  ChangeDetectorRef,
  Attribute,
  HostListener,
  Input
} from '@angular/core';
import { TextFormElement } from '../text/text-form-element';
import { NG_VALUE_ACCESSOR, FormGroup } from '@angular/forms';

@Directive({
  selector: 'input[acInputEmail]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputEmailDirective),
      multi: true
    }
  ]
})
export class InputEmailDirective extends TextFormElement {
  @HostBinding('autocomplete') autocomplete = 'off';
  @Input() formGroup: FormGroup;
  @HostListener('input', ['$event'])
  onChange(event) {
    this.change(event.target.value);
  }

  constructor(
    protected renderer: Renderer2,
    protected el: ElementRef,
    protected csRef: ChangeDetectorRef,
    @Attribute('updateEvent') protected updateEvent
  ) {
    super(renderer, el, csRef, updateEvent);
  }
}
